import React from "react";
import { LogoMark } from "@/components/Header";

export default function Footer() {
    return (
        <footer className="bg-[#1A1715] text-[#B9B0A3] py-10 border-t border-[#3A342C]">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-6">
                <div className="flex items-center gap-2.5">
                    <LogoMark size={30} />
                    <span className="font-serif text-base text-[#F4EFE6]">
                        Solid <span className="text-[#C49A45]">Menswear</span>
                    </span>
                </div>
                <p className="text-xs text-center sm:text-right leading-relaxed max-w-md">
                                    কাস্টমার কেয়ার:{" "}
                                    <a href="tel:+8801960654102" className="text-[#C49A45] font-semibold hover:underline" data-testid="footer-support-phone">
                                        +880 1960-654102
                                    </a>
                                    <br />
                                    আপনার দেওয়া তথ্য শুধুমাত্র অর্ডার প্রসেসিং ও ডেলিভারির কাজে ব্যবহৃত হয়।
                                </p>
                            </div>
                            <p className="text-center text-[11px] text-[#6B645B] mt-6">
                                © {new Date().getFullYear()} Solid Menswear — Created by{" "}
                                <a
                                    href="https://wa.me/8801400859411"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-[#C49A45] font-semibold hover:underline"
                                    data-testid="footer-credit-link"
                                >
                                    GEEKY Digital
                                </a>
                            </p>
                        </footer>
                    );
                }
